import r from "classnames";
import { linkItem as s, visuallyHidden as p, icon as a, iconImage as d, iconComponent as f } from "./SocialLinkItem.css.js";
import { getSocialInfo as u, defaultSocialInfo as N } from "../utils/socialHelpers.js";
import { jsxs as k, jsx as e } from "react/jsx-runtime";
import { Icon as y } from "../icon/Icon.js";
function x({
  element: t,
  className: m,
  children: c
}) {
  const {
    customAttributes: l,
    url: i,
    icon: o
  } = t, n = u(i) || N;
  return /* @__PURE__ */ k("a", {
    ...l,
    className: r(m, s),
    href: i,
    target: "_blank",
    rel: "noopener noreferrer",
    children: [/* @__PURE__ */ e("span", {
      className: p,
      children: n.networkName
    }), o ? /* @__PURE__ */ e("img", {
      src: o,
      alt: n.networkName,
      className: r(a, d)
    }) : null, !o && "iconType" in n && "iconName" in n && /* @__PURE__ */ e(y, {
      type: n.iconType,
      name: n.iconName,
      className: a,
      "aria-hidden": !0
    }), !o && "iconComponent" in n ? /* @__PURE__ */ e("div", {
      className: f,
      children: n.iconComponent
    }) : null, /* @__PURE__ */ e("div", {
      style: {
        display: "none"
      },
      children: c
    })]
  });
}
export {
  x as SocialLinkItemElement
};
